<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="配置键" prop="configKey">
        <a-input
          v-model="form.configKey"
          placeholder="如 pet_weight_step1_img"
          :disabled="formType === 2"
        />
      </a-form-model-item>
      <a-form-model-item label="配置名称" prop="configName">
        <a-input v-model="form.configName" placeholder="请输入配置名称" />
      </a-form-model-item>
      <!-- 图片类配置：仅上传 -->
      <a-form-model-item v-if="isImageConfig" label="配置图片" prop="configValue">
        <file-upload
          v-model="form.configValue"
          type="image"
          :count="1"
          @change="changeConfigImage"
        />
      </a-form-model-item>
      <!-- 文字类配置：仅文本 -->
      <a-form-model-item v-else label="配置值" prop="configValue">
        <a-input v-model="form.configValue" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSiteConfig, addSiteConfig, updateSiteConfig } from '@/api/mibo/siteConfig'

/** 仅支持图片上传的配置键（其余一律文字） */
const IMAGE_CONFIG_KEYS = [
  'pet_weight_step1_img',
  'pet_weight_step2_img'
]

export default {
  name: 'CreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      form: {
        id: null,
        configKey: null,
        configValue: null,
        configName: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        configKey: [
          { required: true, message: '配置键不能为空', trigger: 'blur' }
        ],
        configName: [
          { required: true, message: '配置名称不能为空', trigger: 'blur' }
        ],
        configValue: [
          { required: true, message: '配置值不能为空', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    isImageConfig () {
      const key = this.form && this.form.configKey ? String(this.form.configKey).trim() : ''
      if (!key) {
        return false
      }
      if (IMAGE_CONFIG_KEYS.includes(key)) {
        return true
      }
      // 约定：以 _img 结尾的配置键视为图片配置
      return key.endsWith('_img')
    }
  },
  methods: {
    changeConfigImage (url) {
      this.form.configValue = url
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        configKey: null,
        configValue: null,
        configName: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSiteConfig({ id: id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    submitForm () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        this.submitLoading = true
        const isEdit = this.form.id !== undefined && this.form.id !== null
        const req = isEdit ? updateSiteConfig(this.form) : addSiteConfig(this.form)
        req.then(response => {
          if (response.success) {
            this.$message.success(isEdit ? '修改成功' : '新增成功', 3)
            this.open = false
            this.$emit('ok')
          } else {
            this.$message.error(response.message || response.msg || (isEdit ? '修改失败' : '新增失败'))
          }
        }).finally(() => {
          this.submitLoading = false
        })
      })
    }
  }
}
</script>
